import React from 'react';
import UserInfo from '../../Components/User/UserInfo';
import UserActions from '../../Components/User/UserActions';
import SliderSwiper from '../../Components/Slider/Slider';
//import UserRefLinks from '../../Components/User/UserRefLinks/UserRefLinks';
//import UserRecommended from '../../Components/User/UserRecommended/UserRecommended';
//import UserStudyStatus from '../../Components/User/UserStudyStatus/UserStudyStatus';
import {useGetUserStatTreeQuery} from '../../redux/userApi';
import {useTranslation} from 'react-i18next';
import UserStat2 from './components/UserStat2';
import UserRefLinks from '../../Components/User/UserRefLinks/UserRefLinks';
import UserRecommended from '../../Components/User/UserRecommended/UserRecommended';
import {monthNow} from '../../assets/utils/dateUtils';
import TopTitleBlock from '../../Components/TopTitleBlock/TopTitleBlock';
import s from './PersonalOfficeMain.module.css';
import {useStatusRestriction} from '../../hooks/useStatusRestriction';
//import LidersOfTeam from '../../Components/LidersOfTeam/LidersOfTeam';
import StatusRestrictionMessage from '../../Components/StatusRestrictionMessage/StatusRestrictionMessage';

const PersonalOfficeMain: React.FC = () => {
	const {t} = useTranslation();
	const restrictions = useStatusRestriction();

	const shouldLoadStats =
		(restrictions.canShowMainGraphs || restrictions.canShowMainStat2Links) &&
		!restrictions.isTerminateUser;

	const {data: userStatData} = useGetUserStatTreeQuery(monthNow(), {
		skip: !shouldLoadStats,
	});
	const userStat1 = userStatData?.stat1;
	const userStat2 = userStatData?.stat2;

	return (
		<div className={`page__content ${s.pageContent}`}>
			<TopTitleBlock title={t('Особистий кабінет')} />
			{restrictions.isTerminateUser && (
				<div className={s.blockWrapper}>
					<StatusRestrictionMessage message={t('Кабінет втрачено')} />
				</div>
			)}
			<div className="page__user user">
				<div className="user__row">
					<div className="user__column">
						<UserInfo />
					</div>
					<UserActions />
				</div>
			</div>
			{restrictions.canShowMainGraphs && userStat1 && (
				<SliderSwiper
					statData={userStat1}
					textPoints={t('Балів')}
					userPoints={t('Особистий ТО')}
					checkPoints={t('Мій бонус')}
					bonusMoney={t('Мій партнерський дохід')}
					childPoints={t('Командний ТО')}
					countChild1p={t('Перша лінія')}
					countChild={t('Клієнтів')}
					countActive={t('Активно всього')}
				/>
			)}

			{/*===================================================================*/}
			{restrictions.canShowMainStat2 && (
				<div className={s.blockWrapper}>
					<UserStat2
						data={userStat2}
						showStats={restrictions.canShowMainStat2Links && Boolean(userStat2)}
					/>
				</div>
			)}

			{restrictions.canShowMainReferral && <UserRefLinks />}

			{restrictions.canShowMainRecommendations && <UserRecommended />}

			{/*<LidersOfTeam />*/}
			{/*<UserStudyStatus
				text_my_expertise={apiData.text_my_expertise}
				text_close_lesson={apiData.text_close_lesson}
				text_open_lesson={apiData.text_open_lesson}
				text_study_lesson={apiData.text_study_lesson}
			/>*/}
			{/*<UserStatVolunteer />*/}
		</div>
	);
};

export default PersonalOfficeMain;
